import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import ReviewSection from "@/pages/home/components/ReviewSection";
import StoreSection from "@/pages/home/components/StoreSection";
import UnboxSection from "@/pages/home/components/UnboxSection";
import RankingSection from "@/pages/home/components/RankingSection";
import MethodSection from "@/pages/home/components/MethodSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <Ticker />
        <ReviewSection />
        <StoreSection />
        <UnboxSection />
        <RankingSection />
        <MethodSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
    </div>
  );
}